export function getNextPageParam(lastPage, allPages) {
  return lastPage.meta.isLastPage ? undefined : allPages.length + 1;
}
